import { useMemo, useState } from "react";
import { DataExplorerNode } from "./DataExplorerNode";
import { computeTensorTree, exportJson } from "./safetensors";

export interface DataExplorerProps {
    data: Record<string, any>;
    filename: string;
    download: any;
    selectTensor: any;
    selectedTensor: any;
}

function computeFolders(tree: any, dest: string[] = []): string[] {
    for (const key in tree) {
        if (tree[key] && typeof tree[key] === 'object' && tree[key].type === 'folder') {
            dest.push(tree[key].path);

            computeFolders(tree[key], dest);
        }
    }

    return dest;
}

export const DataExplorer = (props: DataExplorerProps) => {
    const { data, filename, download, selectTensor, selectedTensor } = props;

    const [expanded, setExpanded] = useState<string[]>([]);

    const tree = useMemo(() => computeTensorTree(data), [data]);
    const allFolders = useMemo(() => computeFolders(tree), [tree]);

    const downloadJson = () => exportJson(data, filename.replace(".safetensors", "") + ".metadata.json");
    const downloadButton = <button className="download-label" onClick={downloadJson} title="Downloads the parameter metadata as .json, unedited">export .json tree</button>;
    const numParams = Object.keys(data).length;

    const expandButton = <button className="download-label" onClick={() => setExpanded(allFolders)} title="Expand the entire hierarchy">expand</button>;

    const toggleExpanded = (p: string) => setExpanded(expanded =>
        expanded.includes(p) ? expanded.toSpliced(expanded.indexOf(p), 1) : expanded.concat(p)
    );

    console.dir(tree);
    console.log(expanded);

    return (<>
        <p className="file-title">
            {filename} (T: {numParams}) {downloadButton} {expandButton}
        </p>

        <div className="data-explorer-wrapper">
            <DataExplorerNode
                data={tree}
                depth={0}
                download={download}
                selectTensor={selectTensor}
                selectedTensor={selectedTensor}
                expanded={expanded}
                toggleExpanded={toggleExpanded}
            />
        </div>
    </>
    );
};
